import { render } from "./PanelPublicista.vue?vue&type=template&id=7c701bc4&scoped=true"
import script from "./PanelPublicista.vue?vue&type=script&lang=js"
export * from "./PanelPublicista.vue?vue&type=script&lang=js"

import "./PanelPublicista.vue?vue&type=style&index=0&id=7c701bc4&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c701bc4"]])

export default __exports__